import React from "react";
import { ProgressBar } from "react-bootstrap";

function VideoProgress({
  timer,
  question,
  saveButtonRef,
  onSaveQuestion,
  onEndInterviewClick,
}) {
  return (
    <div className="d-flex justify-content-between align-items-center flex-wrap">
      <div className="progress-bar-container d-flex align-items-center w-100 flex-wrap">
      <p className="font-weight-medium text-grey-4 mb-0 mx-3">Remaining Question: <span className="font-weight-medium text-dark-2">{question?.remaining_ques_count}</span></p>
        <p className="font-weight-medium text-grey-4 mb-0 mx-3">Remaining Time: <span className="font-weight-medium text-dark-2">{question?.remaining_time} mins</span></p>
        {/* <ProgressBar
          now={
            timer > question?.question_detail &&
            question.question_detail?.time_to_answer * 60
              ? question?.question_detail &&
                question.question_detail?.time_to_answer * 60
              : timer
          }
          max={
            question?.question_detail &&
            question.question_detail?.time_to_answer * 60
          }
        />
        <div className="d-flex align-items-center justify-content-between mt-2">
          <span className="text-grey-4 fs-smallest">
            {timer > question?.question_detail &&
            question.question_detail?.time_to_answer * 60
              ? `0${
                  question?.question_detail &&
                  question.question_detail?.time_to_answer
                }:00`
              : `${Math.floor(timer / 60)}:${timer % 60}`}
          </span>
          <span className="text-grey-4 fs-smallest">
            0
            {question?.question_detail &&
              question.question_detail?.time_to_answer}
            :00
          </span>
        </div> */}
      <ul className="d-flex align-items-center flex-wrap">
        <li>
          {/* <button
            className="btn btn-outline-light mr-3 mb-2 mb-md-0"
          >
            Pause Interview
          </button> */}
          <button
            className="btn btn-primary mb-2 mb-md-0 mr-0 mr-sm-3"
            ref={saveButtonRef}
            onClick={onSaveQuestion}
          >
            Save
          </button>
        </li>
        <li>
          <button className="btn btn-danger mb-2 mb-md-0" onClick={() =>onEndInterviewClick()}>
            End Interview
          </button>
        </li>
      </ul>
      </div>
    </div>
  );
}

export default VideoProgress;
